import { useState } from 'react';
import supabase from '../supabase';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const dark = '#4a1010';
const serif = 'Playfair Display, serif';
const body = 'Cormorant Garamond, serif';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Please enter your email and password.');
      return;
    }
    setLoading(true);
    setError('');
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }
    const { data: profile } = await supabase
      .from('profiles')
      .select('role')
      .eq('email', data.user.email)
      .single();
    if (profile?.role === 'admin') {
      window.location.href = '/admin';
    } else {
      window.location.href = '/dashboard';
    }
    setLoading(false);
  };

  const inputStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '0.5px solid #d4c9bc',
    padding: '12px 0',
    fontSize: '15px',
    fontFamily: body,
    color: '#2a1a1a',
    outline: 'none',
    width: '100%'
  };

  return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', fontFamily: body, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: '420px', padding: '60px 40px', border: '1px solid #d4c9bc' }}>
        <p style={{ color: red, fontSize: '11px', letterSpacing: '4px', margin: '0 0 16px', textAlign: 'center' }}>HERMES PORTAL</p>
        <h2 style={{ fontFamily: serif, fontSize: '36px', fontWeight: '700', color: dark, margin: '0 0 8px', textAlign: 'center', lineHeight: '1' }}>Welcome Back</h2>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', margin: '20px 0 40px' }}>
          <div style={{ height: '1px', width: '60px', backgroundColor: '#c9a882' }}></div>
          <div style={{ width: '6px', height: '6px', backgroundColor: '#c9a882', transform: 'rotate(45deg)' }}></div>
          <div style={{ height: '1px', width: '60px', backgroundColor: '#c9a882' }}></div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <input
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
          <input
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
          {error && <p style={{ color: red, fontSize: '13px', margin: 0 }}>{error}</p>}
          <button
            onClick={handleLogin}
            style={{ backgroundColor: red, color: bg, padding: '18px', fontSize: '11px', letterSpacing: '3px', border: 'none', cursor: 'pointer', fontFamily: body, marginTop: '8px' }}
          >
            {loading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>
        </div>
        <p style={{ textAlign: 'center', fontSize: '12px', color: '#888', marginTop: '24px' }}>
          Don't have access? <a href="/contact" style={{ color: red, textDecoration: 'none' }}>Contact us</a>
        </p>
      </div>
    </div>
  );
}

export default Login;